import { render, staticRenderFns } from "./ProgramSocFarmerForm.vue?vue&type=template&id=aac7a110"
import script from "./ProgramSocFarmerForm.vue?vue&type=script&lang=js"
export * from "./ProgramSocFarmerForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports